module.exports = __webpack_public_path__ + "officialStatic/img/product-gw.53fe998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-gw.png
// module id = NnTH
// module chunks = 0